import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import React from "react";
import InsigniaProduct from "../components/MainPageComponents/insignia";
import Exclusives from "../components/InsigniaComponents/exclusivos";

const Insignia = () => {
  return (
    <div>
      <Header />
      <Exclusives />
      <InsigniaProduct
        image="/images/insignia.png"
        title="Superior ESP"
        description="El Superior ESP nace del acople del ESP32 tradicional con una placa de expansión que le brinda una mayor autonomía y amplía sus posibilidades."
        buttonText="Conocé más"
        buttonLink="/insignia/Superior"
      />
      <InsigniaProduct
        title="UNO R4 WIFI"
        description="La nueva placa UNO mucho mejor y más completa a tu alcance. Wifi y Bluetooth integrados, una matriz de leds, mayor frecuencia de reloj y más almacenamiento. Todo lo que necesitás para evolucionar tus proyectos"
        buttonText="Conocé más"
        image="/images/R4/Three.png"
        buttonLink="/insignia/UNOR4"
      />
      <InsigniaProduct
        title="UNO R3"
        description="La UNO R3 es una placa basada en el microcontrolador ATmega328p. Cuenta con 14 pines digitales, 6 pines analógicos, un conector USB, entre otros...
                 Esta nueva presentación de Volteon incluye: Caja, placa UNO R3 (genérico), cable de conexión y manual de usuario."
        buttonText="Conocé más"
        image="/images/UNOR3/Two.png"
        buttonLink="/insignia/UNOR3"
      />
      <Footer />
    </div>
  );
};

export default Insignia;
